import mykhailoPhoto from "@assets/image_1773345523383.png";
import { useSEO } from "@/hooks/use-seo";
import { useState } from "react";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import {
  ArrowRight, Star, CheckCircle, XCircle, ShieldCheck, Gamepad2,
  HeadphonesIcon, Info, Heart, CreditCard, Clock, Mail, MessageCircle,
  Globe, Calendar, Lock, Users, Trophy, Zap, AlertTriangle
} from "lucide-react";
import { Button } from "@/components/ui/button";
import logo12 from "@assets/logos_extracted/12.png";
import { CasinoBreadcrumb } from "@/components/CasinoBreadcrumb";
import { DalsiRecenze } from "@/components/DalsiRecenze";

const CASINO_URL = "https://bbaw.monvaki.com/?mid=282906_1667067";

const tabs = [
  { id: "platby",     label: "Platby",              icon: CreditCard },
  { id: "hry",        label: "Hry",                 icon: Gamepad2 },
  { id: "podpora",    label: "Zákaznická podpora",  icon: HeadphonesIcon },
  { id: "obecne",     label: "Obecné informace",    icon: Info },
  { id: "zodpovedne", label: "Zodpovědné hraní",    icon: Heart },
];

const pros = [
  "Zábavné tropické téma s maskotem vytváří přátelskou atmosféru",
  "Možnost volby mezi více typy uvítacích bonusů (casino nebo sport)",
  "Široká nabídka automatů a stolních her",
  "VIP program s odměnami",
  "Každodenní turnaje a sázkové výzvy",
];

const cons = [
  "Chybí dedikovaná mobilní aplikace",
  "Některé informace o platebních metodách a limitech nejsou transparentně uvedeny",
  "Design může působit méně profesionálně pro hráče hledající seriózní vzhled",
];

function TabContent({ activeTab }: { activeTab: string }) {
  const rowClass = "flex flex-col sm:flex-row sm:items-start gap-1 py-3 border-b border-[#eef1f7] last:border-0";
  const labelClass = "text-gray-500 text-sm sm:w-44 flex-shrink-0";
  const valueClass = "text-gray-900 text-sm font-medium leading-relaxed";

  if (activeTab === "platby") {
    return (
      <div className="divide-y divide-[#eef1f7]">
        <div className={rowClass}><span className={labelClass}>Minimální vklad:</span><span className={valueClass}>250 Kč</span></div>
        <div className={rowClass}><span className={labelClass}>Minimální výběr:</span><span className={valueClass}>250 Kč</span></div>
        <div className={rowClass}><span className={labelClass}>Rychlost výplat:</span><span className={valueClass}>Obvykle do 24 hodin (víkend může prodloužit)</span></div>
        <div className={rowClass}><span className={labelClass}>Karty:</span><span className={valueClass}>Visa, Mastercard</span></div>
        <div className={rowClass}><span className={labelClass}>E-peněženky:</span><span className={valueClass}>Skrill, Neteller, MiFinity, Jetonbank</span></div>
        <div className={rowClass}><span className={labelClass}>Kupóny:</span><span className={valueClass}>Paysafecard</span></div>
        <div className={rowClass}><span className={labelClass}>Online platby:</span><span className={valueClass}>Klarna</span></div>
        <div className={rowClass}><span className={labelClass}>Kryptoměny:</span><span className={valueClass}>Bitcoin, Ripple (XRP), USDT a další</span></div>
        <div className={rowClass}><span className={labelClass}>Bankovní převody:</span><span className={valueClass}>Ano, včetně lokálních variant</span></div>
        <div className={rowClass}><span className={labelClass}>Poplatky kasina:</span><span className={valueClass}>Standardně žádné; poplatek může účtovat zprostředkovatel</span></div>
      </div>
    );
  }
  if (activeTab === "hry") {
    return (
      <div className="divide-y divide-[#eef1f7]">
        <div className={rowClass}><span className={labelClass}>Počet her:</span><span className={valueClass}>Více než 10 000 titulů</span></div>
        <div className={rowClass}><span className={labelClass}>Výherní automaty:</span><span className={valueClass}>Klasiky, video sloty, Megaways, Hold & Win</span></div>
        <div className={rowClass}><span className={labelClass}>Stolní hry:</span><span className={valueClass}>Ruleta, blackjack, baccarat, varianty pokeru</span></div>
        <div className={rowClass}><span className={labelClass}>Live kasino:</span><span className={valueClass}>Ruletové a blackjackové stoly, game shows, baccarat</span></div>
        <div className={rowClass}><span className={labelClass}>Jackpoty:</span><span className={valueClass}>Denní dropy i progresivní varianty</span></div>
        <div className={rowClass}><span className={labelClass}>Sportovní sázky:</span><span className={valueClass}>Ne – čistě online kasino</span></div>
        <div className={rowClass}><span className={labelClass}>Klíčoví poskytovatelé:</span><span className={valueClass}>NetEnt, Evolution, Pragmatic Play, Yggdrasil, Red Tiger, Quickspin, Betsoft, BGaming a další</span></div>
        <div className={rowClass}><span className={labelClass}>Turnaje:</span><span className={valueClass}>Každodenní turnaje a sázkové výzvy</span></div>
      </div>
    );
  }
  if (activeTab === "podpora") {
    return (
      <div className="divide-y divide-[#eef1f7]">
        <div className={rowClass}><span className={labelClass}>Live chat:</span><span className={valueClass}>Ano – 24/7</span></div>
        <div className={rowClass}><span className={labelClass}>E-mail:</span><span className={valueClass}>support@boaboa.com – odpověď zpravidla několik hodin</span></div>
        <div className={rowClass}><span className={labelClass}>Telefonická podpora:</span><span className={valueClass}>Není standardní</span></div>
        <div className={rowClass}><span className={labelClass}>Jazyky podpory:</span><span className={valueClass}>EN, DE, ES, FI, FR, HU, NO, PL, PT, IT, CS a další</span></div>
        <div className={rowClass}><span className={labelClass}>Čeština v podpoře:</span><span className={valueClass}>Není k dispozici</span></div>
        <div className={rowClass}><span className={labelClass}>FAQ sekce:</span><span className={valueClass}>Ano</span></div>
      </div>
    );
  }
  if (activeTab === "obecne") {
    return (
      <div className="divide-y divide-[#eef1f7]">
        <div className={rowClass}><span className={labelClass}>Rok spuštění:</span><span className={valueClass}>2017</span></div>
        <div className={rowClass}><span className={labelClass}>Provozovatel:</span><span className={valueClass}>Stellar Ltd</span></div>
        <div className={rowClass}><span className={labelClass}>Licence:</span><span className={valueClass}>Curacao eGaming (8048/JAZ)</span></div>
        <div className={rowClass}><span className={labelClass}>SSL šifrování:</span><span className={valueClass}>Ano – TLS/SSL na všech citlivých spojeních</span></div>
        <div className={rowClass}><span className={labelClass}>Audit her:</span><span className={valueClass}>TST – testování náhodnosti a výplatní křivky</span></div>
        <div className={rowClass}><span className={labelClass}>Mobilní hraní:</span><span className={valueClass}>Responzivní web – bez stahování</span></div>
        <div className={rowClass}><span className={labelClass}>Čeština:</span><span className={valueClass}>Není k dispozici</span></div>
        <div className={rowClass}><span className={labelClass}>VIP program:</span><span className={valueClass}>Ano – víceúrovňový, sběr bodů, osobní manažer</span></div>
      </div>
    );
  }
  if (activeTab === "zodpovedne") {
    const items: [string, string][] = [
      ["Deposit limity:", "Denní, týdenní a měsíční limity vkladu"],
      ["Dočasné vyloučení:", "Ano"],
      ["Trvalé uzavření účtu:", "Ano"],
      ["Reality check:", "Nastavení upozornění na hraní"],
      ["KYC ověření:", "Povinné před výběrem"],
      ["Věková hranice:", "18+"],
    ];
    return (
      <div className="divide-y divide-[#eef1f7]">
        {items.map(([label, value]) => (
          <div key={label} className="flex flex-col sm:flex-row sm:items-start gap-1 py-3 border-b border-[#eef1f7] last:border-0">
            <span className="text-gray-500 text-sm sm:w-44 flex-shrink-0">{label}</span>
            <span className="text-gray-900 text-sm font-medium leading-relaxed">{value}</span>
          </div>
        ))}
      </div>
    );
  }
  return null;
}

export default function BoaBoaPage() {
  useSEO({ title: "BoaBoa Casino Recenze 2026 – Tropický bonus a sloty | HrajBonus", description: "Recenze BoaBoa Casino. Tropické téma, uvítací bonus, 3000+ slotů a live kasino hry. Rychlé výplaty přes kartu i kryptoměny. 18+",
  url: "https://hrajbonus.com/kasina/boaboa", });

  const [activeTab, setActiveTab] = useState("platby");

  return (
    <>
      <Header />
      <main className="bg-[#f7f9fd] min-h-screen pt-[64px]">

        {/* ── Hero ─────────────────────────────────────────── */}
        <div style={{ background: "linear-gradient(135deg, #001a4d 0%, #002d7c 50%, #003da5 100%)" }}>
          <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-12 xl:px-16 py-10 sm:py-14">
            <div className="flex flex-col lg:flex-row lg:items-center gap-8 lg:gap-12">

              <div className="flex-1">
                <div className="flex items-center gap-6 mb-5">
                  <div className="w-[100px] h-[100px] rounded-xl flex-shrink-0 overflow-hidden shadow-lg">
                    <img src={logo12} alt="Boaboa Casino logo" className="w-full h-full object-cover" />
                  </div>
                  <div>
                    <div className="text-white/60 text-sm font-medium mb-0.5">Recenze kasina</div>
                    <h1 className="text-white font-bold text-2xl sm:text-3xl leading-tight">Kasina BoaBoa</h1>
                    <div className="text-white/50 text-xs mt-0.5">Aktualizováno: 15/02/2026</div>
                  </div>
                </div>

                <div className="flex items-center gap-2 mb-5">
                  <div className="flex gap-0.5">
                    {[1,2,3,4,5,6,7].map(i => (
                      <Star key={i} className="w-5 h-5 fill-[#f5c518] text-[#f5c518]" />
                    ))}
                    <div className="relative w-5 h-5">
                      <Star className="w-5 h-5 text-[#f5c518]/30 absolute inset-0" />
                      <div className="overflow-hidden absolute inset-0" style={{ width: "90%" }}>
                        <Star className="w-5 h-5 fill-[#f5c518] text-[#f5c518]" />
                      </div>
                    </div>
                  </div>
                  <span className="text-white font-bold text-xl">7.9</span>
                  <span className="text-white/50 text-sm">/10</span>
                </div>

                <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
                  {[
                    { label: "Počet her",         value: "10 000+" },
                    { label: "Minimální vklad",   value: "250 Kč" },
                    { label: "Minimální výběr",   value: "250 Kč" },
                    { label: "Rychlost výplat",   value: "do 24 hod." },
                  ].map(s => (
                    <div key={s.label} className="bg-white/10 rounded-lg px-3 py-2.5 backdrop-blur-sm">
                      <div className="text-white/55 text-xs mb-0.5">{s.label}</div>
                      <div className="text-white font-bold text-sm">{s.value}</div>
                    </div>
                  ))}
                </div>

                <div className="mt-3 text-white/50 text-xs font-medium">
                  Přijímá hráče z České republiky
                </div>
              </div>

              <div className="lg:w-[320px] bg-white/10 border border-white/20 rounded-2xl p-6 backdrop-blur-sm">
                <div className="text-center mb-4">
                  <div className="text-white/70 text-sm mb-1">Uvítací bonus</div>
                  <div className="text-white font-black text-2xl leading-tight">až 12 500 Kč</div>
                  <div className="text-[#f5c518] font-bold text-lg">+ 200 free spinů</div>
                  <div className="text-white/50 text-xs mt-1">Wager bonus 35× · Wager FS 40×</div>
                </div>
                <a href={CASINO_URL} target="_blank" rel="sponsored noopener noreferrer" className="block">
                  <Button
                    className="hraj-btn w-full font-bold text-base py-3 gap-2"
                    data-testid="button-hero-cta"
                  >
                    Hraj <ArrowRight className="hraj-arrow w-4 h-4" />
                  </Button>
                </a>
                <p className="text-white/40 text-xs text-center mt-3 leading-relaxed">
                  18+ | Zodpovědné hraní | Platí podmínky
                </p>
              </div>
            </div>
          </div>
        </div>

                <CasinoBreadcrumb casinoName="BoaBoa" />

<div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-12 xl:px-16 py-8 sm:py-12">
          <div className="flex flex-col lg:flex-row gap-8 lg:gap-10">

            <div className="flex-1 min-w-0 space-y-8">

              {/* Author opinion */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm" data-testid="author-opinion">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0"><img src={mykhailoPhoto} alt="Mykhailo Romaenko" className="w-full h-full object-cover" /></div>
                  <div>
                    <div className="font-bold text-gray-900 text-sm">Mykhailo Romaenko</div>
                    <div className="text-gray-400 text-xs">Senior Content Writer</div>
                  </div>
                  <div className="ml-auto text-right">
                    <div className="text-[#003da5] font-black text-xl">7.9</div>
                    <div className="text-gray-400 text-xs">/10 hodnocení</div>
                  </div>
                </div>
                <h2 className="font-bold text-gray-900 text-base mb-2">Recenze boaboa casino: výhody a nevýhody</h2>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Boaboa patří mezi značky, které si získaly pozornost směsí jednoduchého rozhraní, široké nabídky her a bonusů, které dávají smysl i pro zkušené hráče. Působí příjemně exoticky, ale pod kapotou je to poměrně technicky dotažené kasino s rychlými výplatami, pestrými platbami včetně kryptoměn a slušnou stabilitou. Ne všechno je bez chyby, přesto umí nabídnout velmi solidní kombinaci hodnoty a komfortu.
                </p>

                <div className="grid sm:grid-cols-2 gap-4 mt-5">
                  <div>
                    <div className="flex items-center gap-1.5 font-bold text-green-700 text-xs uppercase tracking-wide mb-2">
                      <CheckCircle className="w-3.5 h-3.5" /> Výhody
                    </div>
                    <ul className="space-y-1.5">
                      {pros.map(p => (
                        <li key={p} className="flex items-start gap-1.5 text-gray-700 text-sm">
                          <span className="text-green-500 font-bold mt-0.5 flex-shrink-0">+</span> {p}
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div>
                    <div className="flex items-center gap-1.5 font-bold text-red-600 text-xs uppercase tracking-wide mb-2">
                      <XCircle className="w-3.5 h-3.5" /> Nevýhody
                    </div>
                    <ul className="space-y-1.5">
                      {cons.map(c => (
                        <li key={c} className="flex items-start gap-1.5 text-gray-700 text-sm">
                          <span className="text-gray-400 font-bold mt-0.5 flex-shrink-0">▬</span> {c}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>

              {/* Tabs */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] shadow-sm overflow-hidden" data-testid="casino-overview-tabs">
                <div className="px-5 pt-5 pb-0 border-b border-[#eef1f7]">
                  <h2 className="font-bold text-gray-900 text-base mb-4">Přehled kasina</h2>
                  <div className="flex gap-0 overflow-x-auto -mx-5 px-5">
                    {tabs.map(tab => (
                      <button
                        key={tab.id}
                        onClick={() => setActiveTab(tab.id)}
                        className={`flex items-center gap-1.5 px-3 py-2.5 text-xs font-semibold whitespace-nowrap border-b-2 transition-colors flex-shrink-0 ${
                          activeTab === tab.id
                            ? "border-[#003da5] text-[#003da5]"
                            : "border-transparent text-gray-500 hover:text-gray-700"
                        }`}
                        data-testid={`tab-${tab.id}`}
                      >
                        <tab.icon className="w-3.5 h-3.5" />
                        {tab.label}
                      </button>
                    ))}
                  </div>
                </div>
                <div className="p-5">
                  <TabContent activeTab={activeTab} />
                </div>
              </div>

              {/* First impression */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-black text-gray-900 text-xl sm:text-2xl mb-4">První dojem a pro koho dává Boaboa smysl</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Boaboa sází na přehlednost. Navigace je přímočará, hlavní kategorie jsou na očích a neztrácíte čas hledáním. Všechny klíčové procesy od registrace po vklad jsou lineární a předvídatelné. To ocení každý, kdo nechce strávit půl hodiny studováním rozcestníků a skrytých menu.
                </p>
                <div className="bg-[#f3f6fb] rounded-xl p-4 mb-4">
                  <div className="font-bold text-gray-900 text-sm mb-3">Z pohledu hráčského profilu:</div>
                  <ul className="space-y-1.5">
                    {[
                      "Ideální pro milovníky výherních automatů a live kasina",
                      "Vhodné pro ty, kdo upřednostňují rychlé vklady i výběry, včetně kryptoměn",
                      "Zajímavé pro bonusové hráče, kteří umí pracovat s protočením a využijí opakující se reloady a cashback",
                      "Méně vhodné, pokud potřebujete české rozhraní a lokální měnu Kč",
                    ].map((item, i) => (
                      <li key={i} className="flex items-start gap-1.5 text-gray-600 text-sm">
                        <CheckCircle className="w-4 h-4 text-[#003da5] mt-0.5 flex-shrink-0" /> {item}
                      </li>
                    ))}
                  </ul>
                </div>
                <p className="text-gray-600 leading-relaxed">
                  Jazyková podpora je široká, čeština ale chybí. Komu to nevadí, získá poměrně flexibilní prostředí bez zbytečných kudrlinek.
                </p>

                <div className="mt-4 bg-amber-50 border border-amber-300 rounded-xl p-4 flex gap-3">
                  <AlertTriangle className="w-5 h-5 text-amber-600 mt-0.5 flex-shrink-0" />
                  <p className="text-amber-700 text-sm leading-relaxed">
                    Boaboa provozuje licenci Curacao eGaming (8048/JAZ). Tato licence zaručuje soulad s mezinárodními standardy, avšak není totéž, co lokální česká licence Ministerstva financí ČR – ta zajišťuje vyšší ochranu hráčů v tuzemsku.
                  </p>
                </div>
              </div>

              {/* Security */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Licence, bezpečnost a férovost</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Bezpečnostní základ je postavený na kombinaci šifrování, externího auditu a licencovaného provozu.
                </p>
                <div className="grid sm:grid-cols-2 gap-2 mb-4">
                  {[
                    ["Licence", "Curacao eGaming (8048/JAZ)"],
                    ["Šifrování", "Plné TLS/SSL na všech citlivých spojeních"],
                    ["Audit her", "TST – testování náhodnosti a výplatní křivky"],
                    ["Ochrana dat", "GDPR standardy, bezpečné uchovávání identifikačních dokumentů"],
                  ].map(([label, value]) => (
                    <div key={label} className="flex items-start gap-2">
                      <ShieldCheck className="w-4 h-4 text-[#003da5] mt-0.5 flex-shrink-0" />
                      <div className="text-sm"><span className="font-semibold text-gray-900">{label}:</span> <span className="text-gray-600">{value}</span></div>
                    </div>
                  ))}
                </div>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Curacao licence sama o sobě není totéž, co lokální česká licence, přesto jde o standard u mezinárodních kasin. V kombinaci s dlouhodobě viditelným provozem a dohledatelnými recenzemi to dává slušnou míru jistoty. V reálné praxi hraje největší roli kvalita KYC procesu a transparentnost pravidel. Tady Boaboa působí přísně, občas až důsledněji, než by hráči čekali. Na druhou stranu to přináší vyšší jistotu pro samotné výplaty.
                </p>
              </div>

              {/* UI & Mobile */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Uživatelské rozhraní a mobilní hraní</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Rozhraní je čisté, rychlé a responzivní, jako by bylo navrženo pro špičkové casino. Design neexperimentuje, spíš se drží osvědčené ergonomie: filtry podle kategorií, vyhledávání dle poskytovatelů, přehledné odkazy na bonusy a promo akce. Na mobilu vše funguje stejně svižně, samostatná aplikace není potřeba.
                </p>
                <div className="grid sm:grid-cols-3 gap-3">
                  {[
                    "Bezproblémové přehrávání her od hlavních poskytovatelů",
                    "Live chat dostupný i z mobilní verze",
                    "Bez nutnosti stahovat aplikaci – vše běží v prohlížeči",
                  ].map(item => (
                    <div key={item} className="bg-[#f3f6fb] rounded-xl p-3">
                      <CheckCircle className="w-4 h-4 text-[#003da5] mb-2" />
                      <div className="text-gray-700 text-xs leading-relaxed">{item}</div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Payments */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Platební metody a výplaty</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Hodně silný argument pro Boaboa. Škálu plateb pokrývá od karet přes e-peněženky po kryptoměny. Výplaty jsou obvykle schvalované rychle, typicky do 24 hodin, s upozorněním, že víkend může proces protáhnout.
                </p>
                <div className="overflow-x-auto rounded-xl border border-[#dde4ee] mb-4">
                  <table className="w-full text-sm">
                    <thead>
                      <tr className="bg-[#f3f6fb]">
                        <th className="text-left px-4 py-2.5 text-xs font-bold text-gray-700">Oblast</th>
                        <th className="text-left px-4 py-2.5 text-xs font-bold text-gray-700">Boaboa</th>
                      </tr>
                    </thead>
                    <tbody>
                      {[
                        ["Vklady", "Karty, e-peněženky, Paysafecard, Klarna, bankovní převody, krypto"],
                        ["Výplaty", "Obvykle do 24 hodin; víkend může prodloužit"],
                        ["Kryptoměny", "Ano – BTC, XRP a další"],
                        ["Minimální vklad", "250 Kč"],
                        ["Minimální výběr", "250 Kč"],
                      ].map(([area, value], i) => (
                        <tr key={i} className="border-t border-[#eef1f7]">
                          <td className="px-4 py-2.5 font-semibold text-gray-700 text-xs">{area}</td>
                          <td className="px-4 py-2.5 text-gray-600 text-xs">{value}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div className="bg-amber-50 border border-amber-200 rounded-xl p-3">
                  <p className="text-amber-700 text-xs leading-relaxed">
                    <strong>Tip:</strong> před prvním výběrem dokončete KYC, výplata většinou proběhne výrazně rychleji.
                  </p>
                </div>
              </div>

              {/* Games */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Herní nabídka a vývojáři</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Rozsah portfolia online kasino Boaboa odpovídá velkým mezinárodním značkám. V Boaboa Casino najdete tisíce automatů i silné live studio.
                </p>
                <div className="grid sm:grid-cols-2 gap-3 mb-4">
                  {[
                    ["Automaty", "Klasiky, moderní video sloty, Megaways, Hold & Win"],
                    ["Stolní hry", "Ruleta, blackjack, baccarat, různé varianty pokeru"],
                    ["Live casino", "Ruletové a blackjackové stoly, game shows, baccarat"],
                    ["Jackpoty", "Denní dropy i progresivní varianty dle nabídky poskytovatelů"],
                  ].map(([type, desc]) => (
                    <div key={type} className="bg-[#f3f6fb] rounded-xl p-3">
                      <div className="font-semibold text-gray-900 text-xs mb-1">{type}</div>
                      <div className="text-gray-600 text-xs">{desc}</div>
                    </div>
                  ))}
                </div>
                <p className="text-gray-600 text-sm leading-relaxed mb-3">
                  Mezi vývojáři figurují jména, která určují trend: NetEnt, Evolution, Pragmatic Play, Yggdrasil, Red Tiger, Quickspin, Betsoft, BGaming, Booongo a další. To je prakticky záruka vyvážené kombinace volatilních slotů, dobrých RTP a špičkové kvality streamu v live casinu.
                </p>
                <div className="bg-[#f0f5ff] border border-[#003da5]/15 rounded-xl p-3">
                  <p className="text-[#003da5] text-xs font-medium">
                    Boaboa casino je čistě online kasino. Nepřidává sportovní sázky ani loterijní produkty, takže rozhraní zůstává soustředěné na jednu věc.
                  </p>
                </div>
              </div>

              {/* Bonuses */}
              <div id="bonusy" className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Bonusy: uvítací balíček, reloady, cashback a věrnost</h2>
                <p className="text-gray-600 leading-relaxed mb-5">
                  Bonusová politika patří k silným stránkám. Uvítací balíček je nastaven tak, aby dával výhodu jak nováčkům, tak těm, kdo chtějí vyzkoušet širší spektrum her.
                </p>

                <div className="bg-[#f0f5ff] border border-[#003da5]/15 rounded-xl p-4 mb-5">
                  <div className="text-[#003da5] font-black text-xl mb-0.5">100% bonus k prvnímu vkladu</div>
                  <div className="text-[#c9960f] font-bold text-base mb-1">maximálně 12 500 Kč + 200 free spinů</div>
                  <div className="text-gray-500 text-xs">Minimální vklad: 250 Kč · Wager bonus: 35× · Wager FS: 40×</div>
                </div>

                <div className="grid sm:grid-cols-2 gap-3 mb-5">
                  {[
                    { title: "Pondělní reload", value: "50% až 5 000 Kč" },
                    { title: "Cashback", value: "Až 15% – středotýdenní, často bez dalšího protočení" },
                    { title: "Páteční free spiny", value: "Orientačně 50 FS na vybraných hrách" },
                    { title: "Víkendové speciály", value: "Například 40 FS ke vkladu" },
                    { title: "VIP program", value: "Víceúrovňový, sběr bodů, osobní manažer u vyšších úrovní" },
                    { title: "Každodenní turnaje", value: "Sázkové výzvy a promo kalendář" },
                  ].map(({ title, value }) => (
                    <div key={title} className="bg-[#f3f6fb] rounded-xl p-3">
                      <div className="font-semibold text-gray-900 text-xs mb-0.5">{title}</div>
                      <div className="text-gray-600 text-xs">{value}</div>
                    </div>
                  ))}
                </div>

                <div className="overflow-x-auto rounded-xl border border-[#dde4ee] mb-4">
                  <table className="w-full text-sm">
                    <thead>
                      <tr className="bg-[#f3f6fb]">
                        <th className="text-left px-4 py-2.5 text-xs font-bold text-gray-700">Bonus</th>
                        <th className="text-left px-4 py-2.5 text-xs font-bold text-[#003da5]">Boaboa</th>
                      </tr>
                    </thead>
                    <tbody>
                      {[
                        ["Uvítací balíček",  "100% do 12 500 Kč + 200 FS"],
                        ["Wager",           "Bonus 35× / FS 40×"],
                        ["Reload",          "Pondělí 50% do 5 000 Kč"],
                        ["Cashback",        "Až 15%, podmínky kampaní se liší"],
                        ["Pravidelné FS",   "Pátek 50 FS + víkendové speciály"],
                      ].map(([bonus, value], i) => (
                        <tr key={i} className="border-t border-[#eef1f7]">
                          <td className="px-4 py-2.5 font-semibold text-gray-700 text-xs">{bonus}</td>
                          <td className="px-4 py-2.5 text-gray-600 text-xs">{value}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                <div className="bg-amber-50 border border-amber-200 rounded-xl p-3">
                  <p className="text-amber-700 text-xs leading-relaxed">
                    <strong>Poznámka:</strong> detaily se v čase mění. Před aktivací si vždy otevřete aktuální pravidla dané akce v pokladně.
                  </p>
                </div>
              </div>

              {/* Registration guide */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Rychlý návod: registrace, první vklad a aktivace bonusu</h2>
                <div className="space-y-3 mb-5">
                  {[
                    "Otevřete si registraci a vyplňte základní údaje",
                    "Nastavte si limity pro zodpovědné hraní, volitelně dvoufaktorové ověření e-mailu či telefonu",
                    "Vložte první vklad vhodnou metodou",
                    "V pokladně aktivujte uvítací bonus, zkontrolujte minimální vklad a seznam povolených her pro protočení",
                    "Ověřte účet v sekci KYC, nahrajte čitelné kopie dokladů",
                    "Hrajte hry s příspěvkem do protočení 100 % (typicky sloty)",
                    "Po splnění požadavků požádejte o výplatu stejnou metodou, kterou jste vkládali",
                  ].map((step, i) => (
                    <div key={i} className="flex items-start gap-3">
                      <span className="text-[#003da5] font-black text-sm flex-shrink-0 mt-0.5">{i + 1}.</span>
                      <div className="text-gray-600 text-sm leading-relaxed">{step}</div>
                    </div>
                  ))}
                </div>
                <div className="bg-green-50 border border-green-200 rounded-xl p-3">
                  <p className="text-green-700 text-xs leading-relaxed">
                    <strong>Tip:</strong> sledujte promo kalendář. Pondělní reload a páteční free spiny jsou jednoduchým způsobem, jak si přidat hodnotu bez složitých podmínek.
                  </p>
                </div>
              </div>

              {/* Support */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Lokalizace a zákaznická podpora</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Boaboa komunikuje v řadě jazyků, čeština mezi nimi zatím není. To je jediná výraznější slabina pro hráče, kteří trvají na plné české lokalizaci včetně podpory a měny.
                </p>
                <div className="grid sm:grid-cols-3 gap-3 mb-4">
                  <div className="flex items-start gap-3 p-3 bg-green-50 border border-green-100 rounded-xl">
                    <MessageCircle className="w-5 h-5 text-green-600 mt-0.5 flex-shrink-0" />
                    <div>
                      <div className="font-semibold text-gray-900 text-sm">Live chat</div>
                      <div className="text-green-600 text-xs">24/7, odpověď v řádu minut</div>
                    </div>
                  </div>
                  <div className="flex items-start gap-3 p-3 bg-green-50 border border-green-100 rounded-xl">
                    <Mail className="w-5 h-5 text-green-600 mt-0.5 flex-shrink-0" />
                    <div>
                      <div className="font-semibold text-gray-900 text-sm">E-mail</div>
                      <div className="text-green-600 text-xs">support@boaboa.com</div>
                    </div>
                  </div>
                  <div className="flex items-start gap-3 p-3 bg-[#f3f6fb] border border-[#dde4ee] rounded-xl">
                    <Clock className="w-5 h-5 text-gray-400 mt-0.5 flex-shrink-0" />
                    <div>
                      <div className="font-semibold text-gray-900 text-sm">Telefon</div>
                      <div className="text-gray-400 text-xs">Není standardní</div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Reputation */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Reputace a reálná zkušenost hráčů</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Na agregátorech recenzí se Boaboa drží v lehce nadprůměrných číslech, což potvrzuje řada informací, které boaboa casino recenze poskytují. Pozitivně se hodnotí šíře herní nabídky, stabilita platformy a variabilita platebních metod. Častým tématem diskuzí je ověřování identity a výplatní procesy. Striktní požadavky na kvalitu dokladů mohou výplaty pozdržet, pokud fotky nebo výpisy nesplní parametry.
                </p>
                <div className="bg-[#f3f6fb] rounded-xl p-4">
                  <div className="font-bold text-gray-900 text-sm mb-3">Co z toho plyne v praxi:</div>
                  <ul className="space-y-1.5">
                    {[
                      "Schovejte si kvalitní kopie dokladů, ideálně barevně a bez ořezů",
                      "Adresu potvrďte dokumentem s jasně čitelným jménem a datem",
                      "Používejte k výplatě stejnou metodu, přes kterou jste vkládali",
                    ].map(item => (
                      <li key={item} className="flex items-start gap-1.5 text-gray-600 text-sm">
                        <CheckCircle className="w-4 h-4 text-[#003da5] mt-0.5 flex-shrink-0" /> {item}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>

              {/* Tips */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Tipy, jak si udržet náskok nad podmínkami</h2>
                <ul className="space-y-2">
                  {[
                    "Čtěte bonusové T&C přímo v pokladně, affiliate stránky mohou mít starší údaje",
                    "Využívejte automaty se 100% příspěvkem do protočení, ruleta a stolovky mívají výrazně nižší",
                    "Držte se limitů sázky na spin, které jsou pro bonus povolené",
                    "Jakmile splníte wager, přepněte se na standardní hru bez bonusu a požádejte o výplatu",
                    "Pokud používáte krypto, hlídejte si správnou síť a jedinečné adresy pro vklad",
                  ].map(item => (
                    <li key={item} className="flex items-start gap-2 text-gray-600 text-sm">
                      <span className="text-[#003da5] font-bold mt-0.5 flex-shrink-0">→</span> {item}
                    </li>
                  ))}
                </ul>
              </div>

              {/* FAQ */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-5">Nejčastější otázky</h2>
                <div className="space-y-4">
                  {[
                    {
                      q: "Jak rychle proběhne výplata?",
                      a: "Obvykle do 24 hodin od schválení. O víkendu může schvalování nabrat zpoždění. E-peněženky a krypto bývají nejrychlejší.",
                    },
                    {
                      q: "Je uvítací bonus připsán automaticky?",
                      a: "Většinou ano, ale vždy zkontrolujte v pokladně, zda je promo aktivní, případně vložte kód uvedený u nabídky. Sledujte minimální vklad.",
                    },
                    {
                      q: "Platí se poplatky za vklad nebo výběr?",
                      a: "Standardně ne ze strany kasina. Poplatek může účtovat zprostředkovatel platby nebo blockchain u kryptoměn.",
                    },
                    {
                      q: "Mohu hrát z mobilu bez aplikace?",
                      a: "Ano. Web je responzivní a hry běží přímo v prohlížeči.",
                    },
                    {
                      q: "Co když mi bonus nešel aktivovat?",
                      a: "Ověřte, jestli byl splněn minimální vklad, zda nejste vyloučeni z promoakcí kvůli zemi a jestli nejsou omezené některé platební metody. Když ani to nepomůže, napište na live chat.",
                    },
                    {
                      q: "Jaké doklady jsou potřeba pro ověření?",
                      a: "Standardně občanský nebo cestovní pas, doklad potvrzující adresu (např. účet za energie) a někdy potvrzení držení platební metody. Dbejte na čitelnost a aktuálnost dokumentů.",
                    },
                    {
                      q: "Mohu si bonusové otočky nechat na později?",
                      a: "Většina free spinů má časové omezení. Aktivujte a protočte je v okně, které je uvedené u promo akce.",
                    },
                  ].map(({ q, a }) => (
                    <div key={q} className="border-b border-[#eef1f7] pb-4 last:border-0 last:pb-0">
                      <div className="font-semibold text-gray-900 text-sm mb-1.5">{q}</div>
                      <div className="text-gray-600 text-sm leading-relaxed">{a}</div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Responsible gaming */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Odpovědné hraní a limity</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Boaboa nabízí standardní nástroje, které pomohou udržet hru pod kontrolou:
                </p>
                <div className="grid sm:grid-cols-3 gap-2">
                  {[
                    "Denní, týdenní a měsíční deposit limity",
                    "Možnost dočasného vyloučení a trvalého uzavření účtu",
                    "Nastavení reality check upozornění",
                  ].map(item => (
                    <div key={item} className="flex items-start gap-2 bg-[#f3f6fb] rounded-xl p-3">
                      <ShieldCheck className="w-4 h-4 text-[#003da5] mt-0.5 flex-shrink-0" />
                      <span className="text-gray-700 text-xs leading-relaxed">{item}</span>
                    </div>
                  ))}
                </div>
                <div className="mt-3 bg-green-50 border border-green-200 rounded-xl p-3">
                  <p className="text-green-700 text-xs leading-relaxed">
                    <strong>Doporučení:</strong> nastavte si limity hned po registraci. Lépe se drží plán, když ho máte v systému.
                  </p>
                </div>
              </div>

              {/* Summary */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Závěr</h2>
                <p className="text-gray-600 leading-relaxed">
                  Boaboa umí být velmi příjemné online kasino pro každodenní hru. Působí stabilně, má velkou šíři her, bonusy s rozumným wageringem a výplaty, které nezdržují, když je účet ověřený. Pokud vás netrápí absence češtiny a chcete spíš univerzální prostředí s bohatou nabídkou automatů i live stolů, dává výběr smysl.
                </p>
              </div>

              {/* Author bio */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm" data-testid="author-bio">
                <div className="flex items-center gap-4 mb-4">
                  <div className="w-14 h-14 rounded-full overflow-hidden flex-shrink-0 ring-4 ring-[#003da5]/10"><img src={mykhailoPhoto} alt="Mykhailo Romaenko" className="w-full h-full object-cover" /></div>
                  <div>
                    <div className="font-bold text-gray-900">Mykhailo Romaenko</div>
                    <div className="text-[#003da5] text-sm font-medium">Senior Content Writer</div>
                  </div>
                </div>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Mykhailo je zkušený autor zaměřený na iGaming, který se dlouhodobě pohybuje v odvětví online hazardu. Má bohatou praxi v psaní článků, které propojují svět hráčů i profesionálů. Jeho specialitou je vytváření hlubokých analýz, přehledných recenzí a trendově orientovaného obsahu, který čtenářům přináší nejen zábavu, ale i znalosti.
                </p>
                <p className="text-gray-600 text-sm leading-relaxed mt-3">
                  Své texty staví na detailním výzkumu a praktické zkušenosti, díky čemuž pomáhá hráčům lépe se orientovat v prostředí online casin.
                </p>
              </div>

            </div>

            {/* ── Sticky sidebar ────────────────────────────── */}
            <aside className="lg:w-[300px] flex-shrink-0">
              <div className="lg:sticky lg:top-[84px] space-y-4">

                <div className="bg-white rounded-2xl border border-[#003da5]/25 shadow-[0_4px_24px_rgba(0,61,165,0.12)] p-5" data-testid="sidebar-cta">
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-12 h-12 rounded-lg bg-[#f3f6fb] flex items-center justify-center overflow-hidden">
                      <img src={logo12} alt="Boaboa Casino" className="w-full h-full object-cover" />
                    </div>
                    <div>
                      <div className="font-bold text-gray-900 text-sm">Boaboa Casino</div>
                      <div className="flex items-center gap-0.5">
                        {[1,2,3,4,5,6,7].map(i => <Star key={i} className="w-3 h-3 fill-[#f5c518] text-[#f5c518]" />)}
                        <div className="relative w-3 h-3">
                          <Star className="w-3 h-3 text-[#f5c518]/30 absolute inset-0" />
                          <div className="overflow-hidden absolute inset-0" style={{ width: "90%" }}>
                            <Star className="w-3 h-3 fill-[#f5c518] text-[#f5c518]" />
                          </div>
                        </div>
                        <span className="text-gray-600 text-xs ml-1">7.9/10</span>
                      </div>
                    </div>
                  </div>
                  <div className="text-center mb-4 bg-[#f3f6fb] rounded-xl py-3">
                    <div className="text-gray-500 text-xs mb-0.5">Uvítací bonus</div>
                    <div className="text-[#003da5] font-black text-xl">až 12 500 Kč</div>
                    <div className="text-[#c9960f] font-bold text-sm">+ 200 free spinů</div>
                    <div className="text-gray-400 text-xs mt-0.5">Wager 35× bonus · 40× FS</div>
                  </div>
                  <a href={CASINO_URL} target="_blank" rel="sponsored noopener noreferrer" className="block">
                    <Button
                      className="hraj-btn w-full font-bold gap-2"
                      data-testid="button-sidebar-cta"
                    >
                      Hraj <ArrowRight className="hraj-arrow w-4 h-4" />
                    </Button>
                  </a>
                  <p className="text-gray-400 text-xs text-center mt-2">18+ | Platí podmínky</p>
                </div>

                <div className="bg-white rounded-2xl border border-[#dde4ee] p-5">
                  <div className="font-bold text-gray-900 text-sm mb-3">Rychlý přehled</div>
                  <div className="space-y-2.5">
                    {([
                      { icon: Calendar,    label: "Rok",             value: "2017" },
                      { icon: Globe,       label: "Provozovatel",    value: "Stellar Ltd" },
                      { icon: Lock,        label: "Licence",         value: "Curacao eGaming (8048/JAZ)" },
                      { icon: Gamepad2,    label: "Počet her",       value: "10 000+" },
                      { icon: CreditCard,  label: "Min. vklad",      value: "250 Kč" },
                      { icon: Zap,         label: "Rychlost výplat", value: "do 24 hodin" },
                      { icon: Trophy,      label: "VIP program",     value: "Víceúrovňový" },
                      { icon: Users,       label: "Live kasino",     value: "Ano – herní show, BJ, ruleta" },
                    ] as const).map(({ icon: Icon, label, value }) => (
                      <div key={label} className="flex items-start gap-2">
                        <Icon className="w-4 h-4 text-[#003da5] mt-0.5 flex-shrink-0" />
                        <div className="min-w-0">
                          <span className="text-gray-400 text-xs">{label}: </span>
                          <span className="text-gray-800 font-medium text-xs">{value}</span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

              </div>
            </aside>

          </div>
        </div>
      </main>
      
        <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-12 xl:px-16 pb-8">
          <DalsiRecenze currentSlug="boaboa" />
        </div>

  
        {/* Related reviews */}
        <div className="max-w-[900px] mx-auto px-4 py-4">
          <p className="text-sm text-gray-500 leading-relaxed text-center">
            <span className="font-semibold text-gray-700">Podobná kasina: </span>
              <a href="/kasina/casinia" className="text-[#003da5] hover:underline" data-testid="review-link-casinia">Casinia</a>
              {" · "}
              <a href="/kasina/wazamba" className="text-[#003da5] hover:underline" data-testid="review-link-wazamba">Wazamba</a>
              {" · "}
              <a href="/kasina/cadoola" className="text-[#003da5] hover:underline" data-testid="review-link-cadoola">Cadoola</a>
            {" · "}
            <a href="/kasina" className="text-[#003da5] hover:underline font-semibold" data-testid="review-link-vsechna">Všechna kasina</a>
            {" · "}
            <a href="/porovnat" className="text-[#003da5] hover:underline" data-testid="review-link-porovnat">Porovnání</a>
          </p>
        </div>
      <Footer />
    </>
  );
}
